<fm-context-menu [position]="menuData.clickPosition"
  class="map-menu-container"
  (closed)="onMenuClosed()"
  (copyCoordinatesClicked)="onCopyCoordinates($event)"
  [menuName]="menuData.markerInfo.title"
  [latLng]="menuData.markerInfo?.latLng"
  [isRightClickDisabled]="true">
  <fm-geofence-menu-content [menuData]="menuData"
    [userPermissions]="userPermissions"
    (closed)="onMenuClosed()"
    (findNearestClicked)="onFindNearestClicked()"
    (zoomToClicked)="onZoomToClicked()"
    (streetViewClicked)="onStreetViewClicked()"
    (editPlaceClicked)="onEditPlaceClicked()"
    (getDirectionToClicked)="onGetDirectionToClicked()"
    (getDirectionFromClicked)="onGetDirectionFromClicked()"
    (locationToGarminClicked)="onLocationToGarminClicked()"></fm-geofence-menu-content>
</fm-context-menu>
